import { EmptyState } from 'components/common'
import { ReactElement } from 'react'

const Plugins = (): ReactElement => {
  return (
    <>
      <EmptyState
        title='No Preview Available'
        description='Plugin configuration preview is not available at this time.'
      />
    </>
  )
}

export default Plugins
